import SpeedometerRightIcon from '@atlaskit/icon-lab/core/speedometer-right';
import * as React from 'react';

export function SvgSpeedFast() {
  return <SpeedometerRightIcon label="" testId="ads-refreshed-icon" />;
}
